// AUTOGENERATED
import * as $runtime from "../runtime.js";
import * as Data$dEnum$dGeneric from "../Data.Enum.Generic/index.js";
import * as Data$dGeneric$dRep from "../Data.Generic.Rep/index.js";
import * as Data$dOrdering from "../Data.Ordering/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dEnumEncoding from "../Foreign.Generic.EnumEncoding/index.js";
import * as Unscramble$dEnum from "../Unscramble.Enum/index.js";
const $FulfillmentMethod = tag => ({tag});
const DeliveryIsSymbol = {reflectSymbol: () => "Delivery"};
const TakeawayIsSymbol = {reflectSymbol: () => "Takeaway"};
const DineInIsSymbol = {reflectSymbol: () => "DineIn"};
const genericTopConstructor = {"genericTop'": Data$dGeneric$dRep.NoArguments};
const genericBottomConstructor = {"genericBottom'": Data$dGeneric$dRep.NoArguments};
const genericBottomSum = {"genericBottom'": /* #__PURE__ */ Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)};
const genericEnumConstructor = /* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments);
const genericEnumSum = /* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(genericEnumConstructor)(genericTopConstructor);
const genericEnumSum1 = /* #__PURE__ */ genericEnumSum(/* #__PURE__ */ genericEnumSum(genericEnumConstructor)(genericBottomConstructor))(genericBottomSum);
const genericBoundedEnumConstructor = /* #__PURE__ */ Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments);
const genericBoundedEnumSum = /* #__PURE__ */ Data$dEnum$dGeneric.genericBoundedEnumSum(genericBoundedEnumConstructor);
const genericBoundedEnumSum1 = /* #__PURE__ */ genericBoundedEnumSum(/* #__PURE__ */ genericBoundedEnumSum(genericBoundedEnumConstructor));
const Delivery = /* #__PURE__ */ $FulfillmentMethod("Delivery");
const Takeaway = /* #__PURE__ */ $FulfillmentMethod("Takeaway");
const DineIn = /* #__PURE__ */ $FulfillmentMethod("DineIn");
const eqFulfillmentMethod = {
  eq: x => y => {
    if (x.tag === "Delivery") { return y.tag === "Delivery"; }
    if (x.tag === "Takeaway") { return y.tag === "Takeaway"; }
    if (x.tag === "DineIn") { return y.tag === "DineIn"; }
    return false;
  }
};
const ordFulfillmentMethod = {
  compare: x => y => {
    if (x.tag === "Delivery") {
      if (y.tag === "Delivery") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "Delivery") { return Data$dOrdering.GT; }
    if (x.tag === "Takeaway") {
      if (y.tag === "Takeaway") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "Takeaway") { return Data$dOrdering.GT; }
    if (x.tag === "DineIn") {
      if (y.tag === "DineIn") { return Data$dOrdering.EQ; }
      $runtime.fail();
    }
    $runtime.fail();
  },
  Eq0: () => eqFulfillmentMethod
};
const genericFulfillmentMethod = {
  to: x => {
    if (x.tag === "Inl") { return Delivery; }
    if (x.tag === "Inr") {
      if (x._1.tag === "Inl") { return Takeaway; }
      if (x._1.tag === "Inr") { return DineIn; }
      $runtime.fail();
    }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "Delivery") { return Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments); }
    if (x.tag === "Takeaway") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)); }
    if (x.tag === "DineIn") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.NoArguments)); }
    $runtime.fail();
  }
};
const showFulfillmentMethod = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(DeliveryIsSymbol);
    const $1 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(TakeawayIsSymbol);
    const $2 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(DineInIsSymbol);
    return x => {
      const $3 = genericFulfillmentMethod.from(x);
      if ($3.tag === "Inl") { return $0["genericShow'"]($3._1); }
      if ($3.tag === "Inr") {
        if ($3._1.tag === "Inl") { return $1["genericShow'"]($3._1._1); }
        if ($3._1.tag === "Inr") { return $2["genericShow'"]($3._1._1); }
        $runtime.fail();
      }
      $runtime.fail();
    };
  })()
};
const unscrambleDecodeFulfillmentMethod = {
  unsafeDecode: /* #__PURE__ */ Unscramble$dEnum.genericUnsafeDecodeEnum(genericFulfillmentMethod)(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum({
    enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("Delivery"), Data$dGeneric$dRep.NoArguments)]
  })(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum({enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("Takeaway"), Data$dGeneric$dRep.NoArguments)]})({
    enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("DineIn"), Data$dGeneric$dRep.NoArguments)]
  })))(Unscramble$dEnum.defaultEnumOptions)
};
const boundedFulfillmentMethod = /* #__PURE__ */ (() => (
  {
    top: genericFulfillmentMethod.to(Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.NoArguments))),
    bottom: genericFulfillmentMethod.to(Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)),
    Ord0: () => ordFulfillmentMethod
  }
))();
const enumFulfillmentMethod = {
  succ: /* #__PURE__ */ Data$dEnum$dGeneric.genericSucc(genericFulfillmentMethod)(genericEnumSum1),
  pred: /* #__PURE__ */ Data$dEnum$dGeneric.genericPred(genericFulfillmentMethod)(genericEnumSum1),
  Ord0: () => ordFulfillmentMethod
};
const boundedEnumFulfillmentMet = /* #__PURE__ */ (() => (
  {
    cardinality: genericBoundedEnumSum1["genericCardinality'"],
    toEnum: Data$dEnum$dGeneric.genericToEnum(genericFulfillmentMethod)(genericBoundedEnumSum1),
    fromEnum: x => genericBoundedEnumSum1["genericFromEnum'"](genericFulfillmentMethod.from(x)),
    Bounded0: () => boundedFulfillmentMethod,
    Enum1: () => enumFulfillmentMethod
  }
))();
const encodeFulfillmentMethod = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEnumEncode(genericFulfillmentMethod)({
    encodeEnum: v => v1 => {
      if (v1.tag === "Inl") { return v.constructorTagTransform("Delivery"); }
      if (v1.tag === "Inr") {
        if (v1._1.tag === "Inl") { return v.constructorTagTransform("Takeaway"); }
        if (v1._1.tag === "Inr") { return v.constructorTagTransform("DineIn"); }
        $runtime.fail();
      }
      $runtime.fail();
    }
  })
};
const decodeFulfillmentMethod = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultEnumDecode(genericFulfillmentMethod)(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum(DeliveryIsSymbol))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum(TakeawayIsSymbol))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum(DineInIsSymbol))))
};
export {
  $FulfillmentMethod,
  Delivery,
  DeliveryIsSymbol,
  DineIn,
  DineInIsSymbol,
  Takeaway,
  TakeawayIsSymbol,
  boundedEnumFulfillmentMet,
  boundedFulfillmentMethod,
  decodeFulfillmentMethod,
  encodeFulfillmentMethod,
  enumFulfillmentMethod,
  eqFulfillmentMethod,
  genericBottomConstructor,
  genericBottomSum,
  genericBoundedEnumConstructor,
  genericBoundedEnumSum,
  genericBoundedEnumSum1,
  genericEnumConstructor,
  genericEnumSum,
  genericEnumSum1,
  genericFulfillmentMethod,
  genericTopConstructor,
  ordFulfillmentMethod,
  showFulfillmentMethod,
  unscrambleDecodeFulfillmentMethod
};
